import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { useScreenBreakpoint, isMobileViewport } from '../../../helpers/screen';
import { parseWowcherPath } from '../../../helpers/url';
import useClientSideEffect from '../../../helpers/useClientSideEffect';
import ThemeContext from '../../../providers/ThemeProvider';
import { getIconMap } from './AddsIconsMapping';

const MainDealAdds = ({
  adverts = [],
  direction = 'left',
  gradient = false,
  speed = 60,
}) => {
  const router = useRouter();
  const theme = useContext(ThemeContext);
  const { details } = parseWowcherPath(router.asPath);
  const breakpoint = useScreenBreakpoint();

  const [addsSpeed, setAddsSpeed] = useState(speed);
  const itemsWithoutMarquee = isMobileViewport() ? 3 : 4;

  useClientSideEffect(() => {
    setAddsSpeed(isMobileViewport() ? speed * 0.5 : speed);
  }, [breakpoint]);

  // hide adds
  if (
    !adverts ||
    !details.isTravel ||
    adverts.length < 1 ||
    adverts[0] === null
  )
    return null;

  const renderAdds = (
    <>
      <ul className="adds-content">
        {adverts.map((item) => (
          <li className="adds-content__item" key={item}>
            {getIconMap(item)}
            <span className="text-truncate">{item}</span>
          </li>
        ))}
      </ul>
      <style global jsx>
        {`
          .adds-content {
            display: flex;
            font-size: 11px;
            margin: 0 auto;
            padding: 0;
            list-style: none;
            white-space: nowrap;
          }
          .adds-content__item {
            display: flex;
            align-items: center;
            padding: 0 25px;
          }
          .adds-content__item .svg-inline--fa {
            flex-shrink: 0;
            margin-right: 3px;
          }
          @media (min-width: ${theme.breakpoints.smUp}) {
            .adds-content {
              font-size: 15px;
              line-height: 26px;
            }
          }
          @media (min-width: ${theme.breakpoints.mdUp}) {
            .adds-content__item {
              padding: 0 75px;
            }
          }
        `}
      </style>
    </>
  );

  const renderAddsWrapper = (items) => {
    return (
      <Marquee direction={direction} gradient={gradient} speed={addsSpeed}>
        {items}
      </Marquee>
    );
  };

  return (
    <>
      <div className="adds-container">
        {adverts.length < itemsWithoutMarquee
          ? renderAdds
          : renderAddsWrapper(renderAdds)}
      </div>
      <style global jsx>
        {`
          .adds-container {
            background: ${theme.colors.carouselAdds};
            display: flex;
            height: 19px;
            left: 0;
            line-height: 19px;
            position: absolute;
            right: 0;
            text-align: center;
            top: 0;
            z-index: 18;
          }
          @media (min-width: ${theme.breakpoints.smUp}) {
            .adds-container {
              height: 26px;
              line-height: 26px;
            }
          }
        `}
      </style>
    </>
  );
};

MainDealAdds.propTypes = {
  adverts: PropTypes.array,
  direction: PropTypes.oneOf(['left', 'right']),
  gradient: PropTypes.bool,
  speed: PropTypes.number,
};

export default MainDealAdds;
